var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('SideBar',{attrs:{"items":_vm.sidebarItems}})]},proxy:true},{key:"topnav",fn:function(){return [_c('TopNav',{attrs:{"role":_vm.role}})]},proxy:true},{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }